<template>
  <v-app>
    <v-alert v-if="!gps" color="orange" dense prominent type="info"
      >Para ejecutar este sistema es necesario encender la geo localización de
      tu dispositivo.</v-alert
    >
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="7" class="main-part d-none d-md-none d-lg-flex">
          <div class="d-flex">
            <!-- <v-img src="@/assets/logo4.png" contain></v-img> -->
            <p>DIGIPATS</p>
          </div>
        </v-col>
        <v-col
          cols="12"
          lg="5"
          class="login-part d-flex align-center justify-center"
        >
          <v-row no-gutters class="align-start">
            <v-col
              cols="12"
              class="login-part d-flex align-center justify-center flex-column"
            >
              <div class="login-wrapper pt-md-4 pt-0">
                <v-container>
                  <v-row class="flex-column">
                    <v-col>
                      <!-- <v-img src="@/assets/logo.png" contain></v-img> -->
                      <!-- <v-img src="@/assets/logo4.png" contain></v-img> -->
                      <v-img
                        max-width="412"
                        src="@/assets/logovml.png"
                        contain
                      ></v-img>
                      <p
                        class="login-slogan display-2 text-center font-weight-medium pb-0"
                      >
                        Bienvenido
                      </p>
                    </v-col>
                    <v-form @submit.prevent="login">
                      <v-col>
                        <v-text-field
                          v-model="email"
                          :rules="emailRules"
                          label="Correo electrónico"
                          autocomplete="false"
                          required
                        ></v-text-field>
                        <v-text-field
                          v-model="password"
                          :rules="passRules"
                          type="password"
                          label="Contraseńa"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col class="d-flex justify-space-between">
                        <v-btn
                          block
                          class="text-capitalize"
                          large
                          :loading="loading"
                          :disabled="
                            password.length === 0 || email.length === 0
                          "
                          color="primary"
                          type="submit"
                        >
                          INGRESAR</v-btn
                        >
                        <!-- <v-btn large text class="text-capitalize primary--text"
                          >OLVIDE LA CONTRASEŃA</v-btn
                        > -->
                      </v-col>
                    </v-form>
                  </v-row>
                </v-container>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { auth, db } from "@/firebase";
import {
  getAuth,
  setPersistence,
  signInWithEmailAndPassword,
  browserLocalPersistence,
} from "firebase/auth";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Login",
  data() {
    return {
      email: "",
      emailRules: [
        (v) => !!v || "Correo electrónico es requerido",
        (v) => /.+@.+/.test(v) || "Correo electrónico no es valido",
      ],
      createFullName: "",
      createEmail: "",
      createPassword: "",
      password: "",
      passRules: [(v) => !!v || "Contraseńa es requerida"],
      error: "",
      gps: true,
      loading: false,
    };
  },
  computed: {
    logged() {
      return this.$store.getters.logged;
    },
  },
  methods: {
    async login() {
      this.loading = true;
      this.error = "";
      try {
        console.log("ingesando");
        const auth = getAuth();
        await setPersistence(auth, browserLocalPersistence);
        const authUser = await signInWithEmailAndPassword(
          auth,
          this.email,
          this.password
        );
        // console.log("user", authUser);
        // const authUser = await auth.signInWithEmailAndPassword(
        //   this.email,
        //   this.password
        // );
        if (authUser) {
          const BuscarUsuario = await db
            .collection("usuarios")
            .where("uiid", "==", authUser.user.uid)
            .get();

          const resUsuario = BuscarUsuario?.docs[0].data();
          const resUsuario_id = BuscarUsuario?.docs[0].id;
          const { login } = resUsuario;
          if (login) {
            this.$store.commit("salir");
            throw new Error(
              "No es posible iniciar sesión, comuníquese con el administrador"
            );
          } else {
            let token = this.token();
            localStorage.setItem("user", authUser?.user?.uid);
            localStorage.setItem("token_login", token);
            this.$store.dispatch("ActualizarLoginUsuario", {
              id: resUsuario_id,
              token_login: token,
              login: true,
              disponibilidad: "Activo en espera",
              ip: "",
            });
            this.$store.dispatch("signUserIn", {
              id: authUser?.user?.uid,
            });
            this.$router.push("/clientes").catch((err) => {
              console.info(err);
            });
            this.$store.dispatch("trazabilidadEstadoUsuarios", {
              descripcion: "Estado actualizado al hacer login",
              estado: "Activo en espera",
              uidcaso: "",
              uidusuario: authUser?.user?.uid,
            });
          }
        }
      } catch (e) {
        console.log(e.message);
        if (
          e.message ===
          "No es posible iniciar sesión, comuníquese con el administrador"
        ) {
          this.handleError(e.message);
          return;
        } else {
          this.handleError("Información incorrecta");
        }
      }
    },
    handleError(message) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
    rand() {
      return Math.random(0).toString(36).slice(2);
    },
    token() {
      return (this.rand() + this.rand() + this.rand() + this.rand()).slice(
        0,
        40
      );
    },
  },
  created() {
    if (localStorage.getItem("cliente") || localStorage.getItem("id")) {
      localStorage.removeItem("cliente");
      localStorage.removeItem("id");
    }
    auth.onAuthStateChanged((user) => {
      if (user && this.logged) {
        this.$router.push("/clientes").catch((err) => {
          console.info(err);
        });
      }
    });
  },
  watch: {
    "$store.state.gps": function () {
      this.gps = this.$store.state.gps;
    },
  },
};
</script>

<style src="./Login.scss" lang="scss" scoped />
